module.exports = __webpack_public_path__ + "static/media/sample_invoice.de37f03b.png";